import QuantityButton from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/OptionItem/Multi/parts/QuantityAdjuster/parts/QuantityButton'
import DecreaseQuantityButton from '@/features/pos/components/buttons/DecreaseQuantityButton'
import IncreaseQuantityButton from '@/features/pos/components/buttons/IncreaseQuantityButton'
import { FC } from 'react'
import { View } from 'react-native'

interface QuantityAdjusterProps {
    quantity: number
    onQuantityChange: (quantity: number) => void
}

const QuantityAdjuster: FC<QuantityAdjusterProps> = ({ quantity, onQuantityChange }) => {
    const handleIncrease = () => onQuantityChange(quantity + 1)

    if (!quantity) return <IncreaseQuantityButton onPress={handleIncrease} />

    const handleDecrease = () => {
        const newQuantity = quantity - 1

        onQuantityChange(newQuantity < 0 ? 0 : newQuantity)
    }

    return (
        <View style={{ flexDirection: 'row', gap: 8 }}>
            <DecreaseQuantityButton onPress={handleDecrease} />
            <QuantityButton quantity={quantity} onPress={handleIncrease} />
        </View>
    )
}

export default QuantityAdjuster
